import {
  Container,
  Grid,
  GridItem,
  TagLabel,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { useRef } from "react";
import emailjs from "@emailjs/browser";
import phoneImg from "../Images/phone.png";

import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Stack,
  Textarea,
  useClipboard,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";
import { Link, NavLink } from "react-router-dom";

export const Contact = () => {
  const form = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_qob6xb4",
        "template_c3rrwwi",
        form.current,
        "iaQzt0b05PFk0fHCy"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };

  return (
    <Container id="contact" color="white" bg="black" maxW="100%">
      <Text
        fontSize={{ base: "22px", lg: "40px" }}
        color="white"
        fontFamily="'Mogra', cursive"
      >
        Don't be a Stranger! Connect with me online.
      </Text>
      <Text fontSize={{ base: "sm", lg: "2xl" }} mt={4}>
        Get in Touch with me via Social Media and Email
      </Text>
      <Flex
        justifyContent="space-around"
        width="80%"
        m="auto"
        direction={{ base: "column", lg: "row" }}
      >
        <Flex
          width={{ base: "100%", md : "50%", lg: "30%" }}
          justifyContent="space-evenly"
          alignItems="center"
          gap={3}
          margin = {{base : "none", md : "auto" , lg : "none"}}
          // border="1px solid red"
          p={{ base: 3, lg: 0 }}
        >
          <div>
            <a href="https://github.com/AnshKathpal" target="_blank">
              <img
                id="contact-github"
                style={{
                  borderRadius: "50%",
                }}
                src="https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png"
                alt=""
              />
            </a>
          </div>

          <div>
            <a
              // style={{ width: "100%" }}
              href="https://www.linkedin.com/in/ansh-kathpal-152352142/" target="_blank"
            >
              <img
                id="contact-linkedin"
                style={{
                  borderRadius: "50%",
                }}
                src="https://cdn1.iconfinder.com/data/icons/logotypes/32/circle-linkedin-512.png"
                alt=""
              />
            </a>
          </div>
          <div>
            <a href="https://www.instagram.com/anshkathpal/?igshid=MzRlODBiNWFlZA%3D%3D" target="_blank">
              <img
                style={
                  {
                    // borderRadius: "50%",
                  }
                }
                src="https://cdn1.iconfinder.com/data/icons/social-circle-3/32/instagram_circle-512.png"
                alt=""
              />
            </a>
          </div>

          <div>
            <NavLink
              // className="link"
              // href={`mailto:anshkathpal17@gmail.com`}
              onClick={() =>
                (window.location = "mailto:anshkathpal17@gmail.com")
              }
              target="ansh"
            >
              <Text display="none">Email</Text>
              <img
                // id="contact-email"
                style={{
                  borderRadius: "50%",
                }}
                src="https://cdn0.iconfinder.com/data/icons/social-messaging-ui-color-shapes/128/message-circle-blue-512.png"
                alt=""
              />
              <Text id="contact-email" display="none"> anshkathpal17@gmail.com </Text>
            </NavLink>
          </div>

          <div>
            <Tooltip label="+91 8448837130">
              <div id="contact-phone">
                <img
                  src="https://cdn4.iconfinder.com/data/icons/popular-items-in-circle-form/480/round-control-dial-mobile-phone-512.png"
                  alt=""
                />
                <Text display="none">+91 8448837130</Text>
              </div>
            </Tooltip>
          </div>
        </Flex>
        <Flex
          padding="30px"
          alignItems="center"
          width={{ base: "100%", lg: "50%" }}
          justifyContent="center"
        >
          <form ref={form} onSubmit={handleSubmit}>
            <FormControl>
              <FormLabel>Name</FormLabel>
              <Input type="text" name="user_name" required></Input>
              <FormLabel>Email</FormLabel>
              <Input type="email" name="user_email" required></Input>
              <FormLabel>Message</FormLabel>
              <Textarea type="text" name="user_message" required></Textarea>
              <Button
                _hover={{ bg: "black", border: "1px solid aqua" }}
                h="40px"
                color="white"
                bg="black"
                variant="outline"
                type="submit"
                className="--btn --btn-primary"
                mt={5}
              >
                Send Message
              </Button>
            </FormControl>
          </form>
        </Flex>
      </Flex>
    </Container>
  );
};
